import React from 'react';
import {BaseMixin, ElementaryMixin} from '../common/common.js';

import {Modal} from './bricks.js';

export default React.createClass({

  //@@viewOn:mixins
  mixins: [
    BaseMixin,
    ElementaryMixin
  ],
  //@@viewOff:mixins

  //@@viewOn:statics
  statics: {
    tagName: 'UU5.Bricks.Outline.Modal',
    classNames: {
      main: 'uu5-bricks-outline-modal'
    }
  },
  //@@viewOff:statics

  //@@viewOn:propTypes
  //@@viewOff:propTypes

  //@@viewOn:getDefaultProps
  //@@viewOff:getDefaultProps

  //@@viewOn:standardComponentLifeCycle
  getInitialState: function () {
    return {
      tag: null,
      props: null
    };
  },
  //@@viewOff:standardComponentLifeCycle

  //@@viewOn:interface
  open: function (tag, props, setStateCallback) {
    this.setState({ shown: true, tag: tag, props: props }, setStateCallback);
    return this;
  },

  close: function (setStateCallback) {
    this.setState({ shown: false, tag: null, props: null }, setStateCallback);
    return this;
  },
  //@@viewOff:interface

  //@@viewOn:overridingMethods
  //@@viewOff:overridingMethods

  //@@viewOn:componentSpecificHelpers
  //@@viewOff:componentSpecificHelpers

  //@@viewOn:render
  render: function () {
    return (
      <Modal {...this.getMainPropsToPass()} shown={this.state.shown} header={this.state.tag}>
        <pre>{this.state.props}</pre>
      </Modal>
    );
  }
  //@@viewOff:render
});


// WEBPACK FOOTER //
// ./bricks/outline-modal.js